<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				label="流程"
				placeholder="选择流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择流程' }]"
			/>
			<van-field
				v-model="form.xmmc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目名称' }]"
			/>
			<van-field
				v-model="form.cgnr"
				label="采购内容"
				placeholder="输入采购内容"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入采购内容' }]"
			/>
			<van-field
				v-model="form.je"
				label="采购金额"
				placeholder="输入采购金额"
				type="numbner"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入采购金额' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
	</div>
</template>

<script>
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "purchase",
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			form: {
				xmmc: "",
				cgnr: "",
				cgje: ""
			},
			processList: [],
			popup: {
				process: false
			}
		};
	},
	mounted() {
		this.getPurchaseList();
	},
	methods: {
		onSubmit() {
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  this.form.je
			});
		},
		getPurchaseList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		}
	}
};
</script>